import { Button, Input, message, Space } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import NewDeviceOtp from './NewDeviceOtp';
import Verify2FA from './Verify2fa';
import { PageHeader } from '../../../theme/theme';
import { bikandaApi } from '../../../methods/baseuri';

const Style = styled.div`
	height: 100%;

	& .with-animation {
		display: grid;
		width: 100%;
		height: 100%;
		grid-template-columns: 1fr;
		grid-template-rows: 1fr 1fr;

		& > *:first-child {
			grid-column: 1 / -1;
			grid-row: 1 / -1;
			background-color: #f2f2f2;
			// background-color: rgba(5, 34, 90, 0.5);
			display: flex;
			justify-content: flex-end;
			align-items: flex-start;
		}

		& > .main-action {
			z-index: 5;
			padding: 20px;
			grid-column: 1 / -1;
			grid-row: 2 / span 1;
			background-color: rgba(255, 255, 255, 0.7);
		}

		@media (min-width: 768px) {
			max-width: 1200px;
			margin: auto;
			grid-template-columns: 1fr 1fr 1fr;
			grid-template-rows: 1fr 1fr 1fr;

			& > *:first-child {
				grid-row: 1 / -1;
				align-items: flex-end;
			}

			& > .main-action {
				grid-row: 2 / span 1;
				grid-column: 2 / span 1;
			}
		}
	}

	& form {
		background-color: white;
		padding: 20px;
		margin-bottom: 20px;
	}

	& .forgot {
		text-decoration: underline;
		display: block;
		width: max-content;
		margin: auto;
		font-size: 16px;
	}
`;

const BikandaForgotPassword = () => {
	const [newDeviceAuth, setNewDeviceAuth] = useState(false);
	const [visible2FAModal, set2FAModalVisible] = useState(false);
	const [auth, setAuth] = useState({
		email: '',
		password: '',
		code: '',
		loading: false,
		newDevice: false,
	});

	const changeLoading = (value: boolean) => {
		setAuth({ ...auth, loading: value });
	};

	const handleSubmit = async () => {
		changeLoading(true);

		try {
			const data = {
				email: auth.email,
				userType: 'Merchant',
			};

			const response: any = await bikandaApi.post(
				'Public/Member/auth/forgot-password',
				data
			);

			if (response.status === 200) {
				message.success(
					response?.data?.message || 'Password changed successful!'
				);
				// navigate('/bikanda/login');
			} else {
				message.error('Password changed failed. Please try again.');
			}
		} catch (error: any) {
			message.error(
				error?.response?.data?.message ||
					'Something went wrong during Password change.'
			);
		} finally {
			changeLoading(false);
		}
	};

	return (
		<Style>
			<NewDeviceOtp
				email={auth.email}
				password={auth.password}
				show={newDeviceAuth}
				open2FAModal={() => {
					set2FAModalVisible(true);
				}}
				turnOff={() => setNewDeviceAuth(false)}
			/>

			<Verify2FA show={visible2FAModal} />

			<div className="with-animation">
				<div>{/** <Lottie animationData={badguy} /> */}</div>
				<div className="main-action">
					<PageHeader style={{ textAlign: 'center' }}>
						Forgot Password
					</PageHeader>

					<form
						onSubmit={(e) => {
							e.preventDefault();
							handleSubmit();
						}}
					>
						<Space size={15} direction="vertical" style={{ width: '100%' }}>
							<Input
								placeholder="Email"
								type="email"
								size="large"
								value={auth.email}
								onChange={(e) => setAuth({ ...auth, email: e.target.value })}
							/>

							<Button
								type="primary"
								loading={auth.loading}
								htmlType="submit"
								block
								size="large"
							>
								Enter
							</Button>
						</Space>
					</form>
					<Link className="forgot" to="/bikanda/login">
						Back to Login
					</Link>
				</div>
			</div>
		</Style>
	);
};

export default BikandaForgotPassword;
